export * from './custom-events';

export const domain = 'GTM';
export const gtmId = window.config.gtmId;